// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`renders and matches snapshot 1`] = `
Object {
  "asFragment": [Function],
  "baseElement": <body>
    <div>
      <div
        class="MuiBox-root MuiBox-root-1"
      >
        <div
          class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
        >
          <label
            class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined MuiFormLabel-filled"
            data-shrink="true"
            for="speciality-select"
            id="speciality-select-label"
          >
            Speciality
          </label>
          <div
            class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
          >
            <select
              aria-invalid="false"
              class="MuiSelect-root MuiSelect-select MuiSelect-outlined MuiInputBase-input MuiOutlinedInput-input"
              id="speciality-select"
            >
              <option
                value="1"
              >
                Speciality 1
              </option>
              <option
                value="2"
              >
                Speciality 2
              </option>
              <option
                value="15"
              >
                Internal Medicine
              </option>
            </select>
            <svg
              aria-hidden="true"
              class="MuiSvgIcon-root MuiSelect-icon MuiSelect-iconOutlined"
              focusable="false"
              viewBox="0 0 24 24"
            >
              <path
                d="M7 10l5 5 5-5z"
              />
            </svg>
            <fieldset
              aria-hidden="true"
              class="PrivateNotchedOutline-root-2 MuiOutlinedInput-notchedOutline"
            >
              <legend
                class="PrivateNotchedOutline-legendLabelled-4 PrivateNotchedOutline-legendNotched-5"
              >
                <span>
                  Speciality
                </span>
              </legend>
            </fieldset>
          </div>
          
        </div>
      </div>
    </div>
  </body>,
  "container": <div>
    <div
      class="MuiBox-root MuiBox-root-1"
    >
      <div
        class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
      >
        <label
          class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined MuiFormLabel-filled"
          data-shrink="true"
          for="speciality-select"
          id="speciality-select-label"
        >
          Speciality
        </label>
        <div
          class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
        >
          <select
            aria-invalid="false"
            class="MuiSelect-root MuiSelect-select MuiSelect-outlined MuiInputBase-input MuiOutlinedInput-input"
            id="speciality-select"
          >
            <option
              value="1"
            >
              Speciality 1
            </option>
            <option
              value="2"
            >
              Speciality 2
            </option>
            <option
              value="15"
            >
              Internal Medicine
            </option>
          </select>
          <svg
            aria-hidden="true"
            class="MuiSvgIcon-root MuiSelect-icon MuiSelect-iconOutlined"
            focusable="false"
            viewBox="0 0 24 24"
          >
            <path
              d="M7 10l5 5 5-5z"
            />
          </svg>
          <fieldset
            aria-hidden="true"
            class="PrivateNotchedOutline-root-2 MuiOutlinedInput-notchedOutline"
          >
            <legend
              class="PrivateNotchedOutline-legendLabelled-4 PrivateNotchedOutline-legendNotched-5"
            >
              <span>
                Speciality
              </span>
            </legend>
          </fieldset>
        </div>
        
      </div>
    </div>
  </div>,
  "debug": [Function],
  "findAllByAltText": [Function],
  "findAllByDisplayValue": [Function],
  "findAllByLabelText": [Function],
  "findAllByPlaceholderText": [Function],
  "findAllByRole": [Function],
  "findAllByTestId": [Function],
  "findAllByText": [Function],
  "findAllByTitle": [Function],
  "findByAltText": [Function],
  "findByDisplayValue": [Function],
  "findByLabelText": [Function],
  "findByPlaceholderText": [Function],
  "findByRole": [Function],
  "findByTestId": [Function],
  "findByText": [Function],
  "findByTitle": [Function],
  "getAllByAltText": [Function],
  "getAllByDisplayValue": [Function],
  "getAllByLabelText": [Function],
  "getAllByPlaceholderText": [Function],
  "getAllByRole": [Function],
  "getAllByTestId": [Function],
  "getAllByText": [Function],
  "getAllByTitle": [Function],
  "getByAltText": [Function],
  "getByDisplayValue": [Function],
  "getByLabelText": [Function],
  "getByPlaceholderText": [Function],
  "getByRole": [Function],
  "getByTestId": [Function],
  "getByText": [Function],
  "getByTitle": [Function],
  "queryAllByAltText": [Function],
  "queryAllByDisplayValue": [Function],
  "queryAllByLabelText": [Function],
  "queryAllByPlaceholderText": [Function],
  "queryAllByRole": [Function],
  "queryAllByTestId": [Function],
  "queryAllByText": [Function],
  "queryAllByTitle": [Function],
  "queryByAltText": [Function],
  "queryByDisplayValue": [Function],
  "queryByLabelText": [Function],
  "queryByPlaceholderText": [Function],
  "queryByRole": [Function],
  "queryByTestId": [Function],
  "queryByText": [Function],
  "queryByTitle": [Function],
  "rerender": [Function],
  "unmount": [Function],
}
`;
